import React, { Component } from 'react'

import { SLIDER_DEFAULT_OPTIONS } from "../const/config";
import Slider from "react-slick";

export default class SlideShow extends Component {
  constructor(props) {
    super(props);

    this.groupRawData = this.groupRawData.bind(this);
  }

  hideSlide = (show) => {
    return (show === true) ? "slick-slider" : "slick-slider show";
  }

  getNewCurrentTheme = () => {
    this.props.getNewCurrentTheme();
  }

  groupRawData = (arr, step) => {
    let group = [];
    for (let i = 0, j = 0; i < arr.length; i++) {
      if (i >= step && i % step === 0) {
        j++;
      }

      group[j] = group[j] || [];
      group[j].push(arr[i]);
    }

    return (group);
  }

  render() {
    let show = this.props.show;
    let demos = [...this.props.demos];
    if (demos.length) {
      let empty_count = 9 - (demos.length % 9);

      for (let i = 0; i < empty_count; i++) {
        demos.push({ "key": "" });
      }
    }

    let sliderGroups = this.groupRawData(demos, 3);
    let markup = (<div className="slider-wrapper">
      <div className="container">
        <Slider {...SLIDER_DEFAULT_OPTIONS} className={this.hideSlide(show)} handleMoreThemes={this.props.handleMoreThemes}>
          {sliderGroups.map((sliderGroup, key) => {
            let firstGroup = (key + 1) % 3 === 1 ? true : false;

            return (
              <SliderGroup
                key={key}
                firstGroup={firstGroup}
                sliderGroup={sliderGroup}
                getNewCurrentTheme={this.props.getNewCurrentTheme}
                show={this.props.show}
                handleMoreThemes={this.props.handleMoreThemes}
              />
            );
          })}
        </Slider>
      </div>
    </div>);
    return (markup);
  }
}

const SliderGroup = (props) => {
  let sliderGroup = props.sliderGroup;
  let className = "slick-slide-group";
  if (props.firstGroup) {
    className += " first-group";
  }

  return (
    <div className={className}>
      {sliderGroup.map((demo, key) => {
        return <SliderItem key={key} demo={demo} getNewCurrentTheme={props.getNewCurrentTheme} show={props.show} handleMoreThemes={props.handleMoreThemes} />;
      })}
    </div>
  );
}

const SliderItem = (props) => {
  let demo = props.demo;
  let show = props.show;

  if (demo.key === "" || demo.class === "") {
    return (
      <div className="slide-inner">
        <div className="group-inner" onClick={(event) => {
          props.getNewCurrentTheme(event)
          props.handleMoreThemes(show)
        }}>
          <a href={demo.link} title={demo.title}  >
            <img src={demo.thumb} alt={demo.title} />
          </a>
          <div className="demo-info">
            <a className="title" href={demo.link} >
              {demo.title}<span className=""></span>
            </a>
          </div>
        </div>
      </div >
    );
  } else {
    return (
      <div className="slide-inner">
        <div className="group-inner" onClick={(event) => {
          props.getNewCurrentTheme(event)
          props.handleMoreThemes(show)
        }}>
          <a href={demo.link} title={demo.title} >
            <img src={demo.thumb} alt={demo.title} />
          </a>
          <div className="demo-info">
            <a className="title" href={demo.link} >
              {demo.title}<span className="state">{demo.class}</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slide.js